<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<leave v-if="fromList[0].show" @sub="onsubmit" ref="childclear" />
		<cost v-if="fromList[1].show" @sub="onsubmit" ref="childclear" />
		<travel v-if="fromList[2].show" @sub="onsubmit" ref="childclear" />
		<report v-if="fromList[3].show" @sub="onsubmit" ref="childclear" />
		<margin v-if="fromList[4].show" @sub="onsubmit" ref="childclear" />
		<purchase v-if="fromList[5].show" @sub="onsubmit" ref="childclear" />
		<chapter v-if="fromList[6].show" @sub="onsubmit" ref="childclear" />
		<Reimburse v-if="fromList[7].show" @sub="onsubmit" ref="childclear" />
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import leave from "./from/take_leave";
import cost from "./from/cost";
import travel from "./from/travel";
import report from "./from/report";
import margin from "./from/margin";
import purchase from "./from/purchase";
import chapter from "./from/chapter";
import Reimburse from "./from/Reimburse";
import { Toast } from "vant";
import { submit } from "@/api/review";

export default {
	components: {
		navbar,
		leave,
		cost,
		travel,
		report,
		margin,
		purchase,
		chapter,
		Reimburse
	},
	data() {
		return {
			form: {},
			title: "新的申请",
			fromList: [
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false }
			]
		};
	},
	mounted() {
		this.fromShow();
	},
	methods: {
		onsubmit(form) {
			this.form = form;
			submit(this.form)
				.then(() => {
					this.$refs.childclear.clearForm();
					return Toast.success("申请成功!");
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		fromShow() {
			this.fromList[this.$route.query.type].show = true;
		}
	}
};
</script>

<style>
</style>
